import Vue from 'vue';
import Vuex from 'vuex';

import common from './modules/common';
import user from './modules/user';

import dashboard from './modules/dashboard';

import wine from './modules/wine';
import winery from './modules/winery';
import region from './modules/region';
import grape from './modules/grape';
import aroma from './modules/aroma';
import curation from './modules/curation';
import setting from './modules/service';
import notice from './modules/notice';
import address from './modules/address';
import holiday from './modules/holiday';
import warehouse from './modules/warehouse';
import supplier from './modules/supplier';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    common,
    user,
    dashboard,
    wine,
    winery,
    region,
    grape,
    aroma,
    curation,
    setting,
    notice,
    address,
    holiday,
    warehouse,
    supplier,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js